/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.getAmazonProductVariants.internal

import features.getAmazonProductVariants.models.RewardResponseModel
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest
import kangaroorewards.appsdk.core.network.base.PathParameter
import kangaroorewards.appsdk.core.network.base.replaceInPath

internal class GetAmazonProductVariantsRequest : NetworkRequest() {

    suspend fun getAmazonProductVariants(
        overrideHeaders: Map<String, String>? = null,
        rewardId: Int,
        externalProductId: String
    ): IOResult<RewardResponseModel> {
        return safeNetworkCall {
            get(
                endpoint = GetAmazonProductVariantsEndpoint.replaceInPath(
                    PathParameter("rewardId", rewardId),
                    PathParameter("externalProductId", externalProductId),
                ),
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
